module.exports = __webpack_public_path__ + "img/logo_white.dd35f139.png";